<template>
  <base-widget
    icon="currency-dollar"
    :loading="isLoading"
    :title="$t('Payroll')"
  >
    <oxd-bar-chart
      :grid="false"
      :data="dataset"
      :y-axsis="false"
      :aspect-ratio="false"
      wrapper-classes="emp-attendance-chart"
    ></oxd-bar-chart>
    <oxd-divider />
    <div class="orangehrm-attendance-card-summary">
      <div class="orangehrm-attendance-card-summary-week">
        <oxd-text tag="p"> Total Net Paid: {{ totalNet }} </oxd-text>
      </div>
    </div>
    <oxd-pie-chart
      :data="piedataset"
      :aspect-ratio="false"
      :custom-legend="true"
      :custom-tooltip="true"
      wrapper-classes="emp-attendance-chart"
    ></oxd-pie-chart>
  </base-widget>
</template>
<script>
import {navigate} from '@/core/util/helper/navigation';
import useLocale from '@/core/util/composable/useLocale';
import {APIService} from '@/core/util/services/api.service';
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';
import {OxdBarChart, OxdPieChart, OxdIcon, CHART_COLORS} from '@ohrm/oxd';

export default {
  name: 'PayrollWidget',

  components: {
    'base-widget': BaseWidget,
    'oxd-bar-chart': OxdBarChart,
    'oxd-pie-chart': OxdPieChart,
  },

  setup() {
    const {locale} = useLocale();
    const http = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/pim/paystubs',
    );

    return {
      http,
      locale,
    };
  },

  data() {
    return {
      dataset: [],
      piedataset: [],
      isLoading: false,
      totalNet: 0,
    };
  },

  async beforeMount() {
    this.fetchWidgetData();
  },
  methods: {
    fetchWidgetData() {
      this.isLoading = true;
      this.http
        .getAll({})
        .then((response) => {
          const {data, meta} = response.data;
          const {total, totalNet} = meta;

          const colors = [
            CHART_COLORS.COLOR_HEAT_WAVE,
            CHART_COLORS.COLOR_CHROME_YELLOW,
            CHART_COLORS.COLOR_YELLOW_GREEN,
            CHART_COLORS.COLOR_MOUNTAIN_MEADOW,
            CHART_COLORS.COLOR_PACIFIC_BLUE,
            CHART_COLORS.COLOR_BLEU_DE_FRANCE,
            CHART_COLORS.COLOR_MAJORELLE_BLUE,
            CHART_COLORS.COLOR_MEDIUM_ORCHID,
            CHART_COLORS.COLOR_FANDANGO_PINK,
          ];

          // Group the amounts by types
          const amountsByName = data.reduce((acc, item) => {
            const fullName = item.firstName + ' ' + item.lastName;
            acc[fullName] = (acc[fullName] || 0) + parseFloat(item.netPay);
            return acc;
          }, {});

          // Prepare data for the pie chart
          const pielabels = Object.keys(amountsByName);
          const amounts = Object.values(amountsByName); // Corresponding amounts

          // Update the dataset
          this.piedataset = pielabels.map((type, index) => ({
            label: type,
            value: parseFloat((amounts[index] || 0).toFixed(2)),
            color: colors[index],
          }));

          // Group data by month
          const monthlyData = data.reduce((acc, paystub) => {
            const month = new Date(paystub.endDate).toISOString().slice(0, 7); // Get year-month
            acc[month] = (acc[month] || 0) + parseFloat(paystub.netPay);
            return acc;
          }, {});

          const sortedMonthlyData = Object.entries(monthlyData)
            .sort(([monthA], [monthB]) => new Date(monthA) - new Date(monthB)) // Sort by date
            .reduce((acc, [month, amount]) => {
              acc[month] = amount;
              return acc;
            }, {});

          // Prepare data for the chart
          const labels = Object.keys(sortedMonthlyData);
          const chartData = Object.values(sortedMonthlyData);
          this.totalNet = totalNet;
          // Update the dataset
          this.dataset = labels.map((month, index) => ({
            label: month,
            value: chartData[index],
            color: colors[index], //CHART_COLORS.COLOR_HEAT_WAVE, // Use a predefined color or customize as needed
          }));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style src="./employee-attendance-widget.scss" lang="scss" scoped></style>
